const getScrollableParent = (element) => {
  if (
    // must exist
    element && // must have room to scroll
    element.scrollHeight > element.offsetHeight && // must be allowed to scroll by the css
    ["scroll", "auto"].includes(getComputedStyle(element).overflowY)
  ) {
    return element;
  } else if (element.parentElement) {
    return getScrollableParent(element.parentElement);
  }
  return null;
};
const handleStickyScroll = (element, { onStickyChange }) => {
  if (!element) {
    return () => null;
  }
  const scrollableParent = getScrollableParent(element);
  let isStuck = false;
  const handleScroll = () => {
    const isScrolled = Boolean(scrollableParent?.scrollTop || window.scrollY);
    if (isScrolled && !isStuck) {
      isStuck = true;
      onStickyChange(isStuck);
    } else if (!isScrolled && isStuck) {
      isStuck = false;
      onStickyChange(isStuck);
    }
  };
  (scrollableParent || window).addEventListener("scroll", handleScroll);
  return () => {
    (scrollableParent || window).removeEventListener("scroll", handleScroll);
  };
};
export {
  getScrollableParent,
  handleStickyScroll
};
